import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import axios from '../../axios-vmou';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import Navbar from "../main/navbar";
import logo from "../../assets/vmou.png";
import { Sidebar } from 'primereact/sidebar';
import styles from '../batch/batchtable.module.css';
import { useHistory } from "react-router-dom";
import * as actions from '../../store/actions/index'

const Extratable = (props) => {
    const [visibleRight, setVisibleRight] = useState(false);
    const onSignout = () => {
        props.onlogout();
      }
    const [batch, setBatch] = useState('');
    const [batches, setBatches] = useState(null);
    const [sendDialog, setSendDialog] = useState(false);
    const [recdDialog, setRecdDialog] = useState(false);
//    const [exams, setExams] = useState('');
    const [mode,setMode] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('Unassigned');
    const [examinerList, setExamierList] = useState('');
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const history = useHistory()

    const statuses = [
        "Unassigned",
        "Assigned",
        "All"
    ]

    const exams = [
        "JUNE23"
    ]
    const [selectedExam, setSelectedExam] = useState(exams[0]);

    useEffect(() => {
        let authOptions = {
            method: 'PUT',
            url: '/extra/Coord/', 
            data: {'userid':props.userid,'exam':selectedExam},
                headers : {
                'x-auth-token' : localStorage.getItem('token')
            }
        };
        axios(authOptions)
        .then(response => {
            setBatches(response.data)
        })
        .catch(error => {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
            setBatches([]);
        });
        authOptions = {
            method: 'GET',
            url: '/examiner/Coord/'+props.userid, 
            data: {'userid':props.userid},
                headers : {
                'x-auth-token' : localStorage.getItem('token')
            }
        };
        axios(authOptions)
        .then(response => {
            setExamierList(response.data)
        })
        .catch(error => {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
            setExamierList([]);
        });
    },[props.userid,selectedExam]); 


    const hideSendDialog = () => {
        setSendDialog(false);
    }

    const hideRecdDialog = () => {
        setRecdDialog(false);
    }
    const saveBatch = () => {
        let _batches = [...batches];
        let _batch = {...batch};
        if (mode === 'Send') {
            if (batch.examinerid) {
                let authOptions = {
                  method: 'PUT',
                  url: '/extra/send', 
                  data: _batch,
                  headers : {
                      'x-auth-token' : localStorage.getItem('token')
                  }
                };
                axios(authOptions)
                    .then(response => {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Batch Edited', life: 3000 });
                    setBatches(_batches);
                    setSendDialog(false);
                })
                  .catch(error => {
                    toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
                });
            } else {
                toast.current.show({severity: 'error', summary: 'Error Message', detail:"Examiner NOT Selected"});
            }
        } else  {
            if (batch.examinerid) {
                let authOptions = {
                  method: 'PUT',
                  url: '/extra/recd', 
                  data: _batch,
                  headers : {
                      'x-auth-token' : localStorage.getItem('token')
                  }
                };
                axios(authOptions)
                    .then(response => {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Batch Edited', life: 3000 });
                    setBatches(_batches);
                    setRecdDialog(false);
                })
                  .catch(error => {
                    toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
                });
            } else {
                toast.current.show({severity: 'error', summary: 'Error Message', detail:"Examiner NOT Selected"});
            }
        }

    }
    const examSearch = (event) => {
        event.preventDefault();  
       let authOptions = {
        method: 'PUT',
        url: '/extra/Coord/', 
        data: {'userid':props.userid,'exam':selectedExam, 'sts': selectedStatus},
        headers : {
            'x-auth-token' : localStorage.getItem('token')
        }
      };
      axios(authOptions)
      .then(response => {
        setBatches(response.data);
      })
      .catch(error => {
        toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
        setBatches([]);
    });
    }
    
    const sendBatch = (batch) => {
        setBatch({...batch});
        setMode('Send');
        setSendDialog(true);
    }
    const recdBatch = (batch) => {
        setBatch({...batch});
        setMode('Recd');
        setRecdDialog(true);
    }
    const awlblank = (batch) => {
        setBatch({...batch});
        history.push({
            pathname: '/AWLBLANK',
            state: {po:batch}
        });
          }

    const exportCSV = () => {
        dt.current.exportCSV();
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _batch = {...batch};
        _batch[`${name}`] = val;
        setBatch(_batch);
    }

    const onExaminerChange = (e) => {
        const val = (e.target && e.target.value) || '';
        let _batch = {...batch};
        _batch.examinerid= val;
        setBatch(_batch);
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-arrow-right" tooltip="Send to Examiner" tooltipOptions={{position: 'left'}} className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => sendBatch(rowData)} />
                <Button icon="pi pi-arrow-left" tooltip="Send to VMOU" tooltipOptions={{position: 'left'}} className="p-button-rounded p-button-text p-button-warning" onClick={() => recdBatch(rowData)} />
                <Button icon="pi pi-print" tooltip="Blank AwardList" tooltipOptions={{position: 'left'}} className="p-button-rounded p-button-text " onClick={() => awlblank(rowData)} />
           </React.Fragment>
        );
    }

    const header = (
        <div className={styles.tableheader}>
            <h4 className="mx-0 my-1">Manage Extra Copies</h4>
            <Button label="Export" icon="pi pi-upload" className="p-button-help mr-6" onClick={exportCSV} />
            <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );
    const batchSendDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideSendDialog} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={saveBatch} />
        </React.Fragment>
    );
    const batchRecdDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideRecdDialog} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={saveBatch} />
        </React.Fragment>
    );

    const formatDate = (dt) => {
        let cdt = new Date(dt);
        let month = cdt.getMonth() + 1;
        let day = cdt.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return (dt)?day+"-"+month+"-"+cdt.getFullYear():'' ;
      };
    
    
    const dateBodyTemplate1 = (rowData) => formatDate(rowData.dteval);
    const dateBodyTemplate2 = (rowData) => formatDate(rowData.dtvmou);

//            <DataTable resizableColumns columnResizeMode="fit" showGridlines className="p-datatable-sm" ref={dt} value={batches} selection={selectedBatches} onSelectionChange={(e) => setSelectedBatches(e.value)}

    return (
    <div className={styles.datatablecruddemo}>
        <Toast ref={toast} />
        <Sidebar className="flex align-items-center " visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
          <h2>User Profile....</h2>
          <h5>Coord ID : {props.email}</h5>
          <h5>Name        : {props.username}</h5>
          <Button className="p-button-text p-button-danger ml-4" style={{}} onClick={onSignout}>Sign Out</Button>
        </Sidebar>
      <div className="Headerusr" style={{ position: "sticky" }}>
        <img
          src={logo}
          alt="VMOU"
          height={100}
          width={90}
          style={{ margin: "0px 0 0 20px" }}
        ></img>
        <h2 style={{ marginTop: "0", textAlign: "center" }}>
          Coordinator Module
          <br />
          Extra Copies Management
        </h2>
        <div className="Userusr" onClick={(e) => setVisibleRight(true)}>
          <i style={{'fontSize': '1.5em'}} className="pi pi-user mr-6 mt-2 text-right"></i>
          <h4 style={{margin:'0 30px 0 0',textAlign:'end'}} >Hi, {props.username}</h4>
        </div>
      </div>
      <Navbar />
        <div className={styles.Sformpr}>
            <div className=" ">
                <label htmlFor="centre" className="">Select Exam</label>
                <Dropdown className="ml-4 my-1 h-auto" value={selectedExam} options={exams} onChange={(e) => setSelectedExam(e.value)}  placeholder="Select Exam" />
            </div>
            <div className=" ">
                <label htmlFor="centre" className="ml-4">Select Copies Status</label>
                <Dropdown className="ml-4 my-1 h-auto" value={selectedStatus} options={statuses} onChange={(e) => setSelectedStatus(e.value)}  placeholder="Select Status" />
            </div>
            <Button icon="pi pi-search" className="ml-2 p-button-text p-button-success" onClick={examSearch}/>
        </div>
        <div className={styles.card}>
  
            <DataTable resizableColumns columnResizeMode="fit" showGridlines className="p-datatable-sm" ref={dt} value={batches} 
                dataKey="ccode" sortField="ccode" sortOrder={1} paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} batches"
                globalFilter={globalFilter} header={header} responsiveLayout="scroll">
                <Column field="batchcode" header="Batch/Examiner No" sortable style={{textAlign:'center',   width: '15%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="ccode" header="Course/Paper" sortable style={{textAlign:'center',   width: '15%', padding:'0 1px 0 1px' }}></Column>
                <Column field="noofcopies" header="No of Copies" style={{textAlign:'center', width: '10%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="examinerid.name" header="Examiner" sortable style={{ textAlign:'left',  width: '20%', padding:'0 1px 0 1px' }}></Column>
                <Column field="dteval" header="Date Eval" body={dateBodyTemplate1} sortable style={{ textAlign:'center',  width: '10%' , padding:'0 1px 0 1px'}}></Column>
                <Column field="dtvmou" header="Date VMOU" body={dateBodyTemplate2} sortable style={{ textAlign:'center',  width: '10%' , padding:'0 1px 0 1px'}}></Column>
                <Column body={actionBodyTemplate} exportable={false} style={{ textAlign:'center', width: '10%' , padding:'0 1px 0 1px'}}></Column>
            </DataTable>
        </div>

        <Dialog visible={sendDialog} style={{ width: '450px' }} header="Sent to Examiner" modal className="p-fluid" footer={batchSendDialogFooter} onHide={hideSendDialog}>
            <div className="p-field mt-2">
                <label htmlFor="centre" className="">Select Examiner</label>
                <Dropdown filter filterBy='name' placeholder="Select Examiner" className=" w-full" id="examiner"  autoComplete="off" optionLabel="name"  options={examinerList} value={batch.examinerid} onChange={onExaminerChange} />
            </div>
            <div className="p-field mt-2">
                <label htmlFor="role" className="">Date Eval</label>
                <Calendar maxDate={new Date()} monthNavigator yearNavigator yearRange="2010:2030" id="frDate" className="h-2rem" value={batch.dtsend} onChange={(e) => onInputChange(e,"dteval")} mask="99/99/9999" dateFormat="dd/mm/yy"/>
            </div>
        </Dialog>
        <Dialog visible={recdDialog} style={{ width: '450px' }} header="Received from Examiner" modal className="p-fluid" footer={batchRecdDialogFooter} onHide={hideRecdDialog}>
            <div className="p-field mt-2">
                <label htmlFor="role" className="">Date VMOU</label>
                <Calendar maxDate={new Date()} monthNavigator yearNavigator yearRange="2010:2030" id="frDate" className="h-2rem" value={batch.dtrecd} onChange={(e) => onInputChange(e,"dtvmou")} mask="99/99/9999" dateFormat="dd/mm/yy"/>
            </div>
        </Dialog>
    </div>
    );
}
const mapStateToProps = state => {
    return {
        username:state.auth.username,
        userid:state.auth.userid,
        email:state.auth.email,
        isAuth:state.auth.token!==null,
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
        onlogout:() => dispatch(actions.logout())
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(Extratable);